module.exports = __webpack_public_path__ + "static/media/IMG_20180806_192227.80f2ac59.jpg";